export default __webpack_public_path__ + "static/media/illust_nomsg.90b46f5c.svg";